import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { TextsProvider } from "@/lib/texts";
import { scrollToId } from "@/lib/content";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { WhyUs } from "@/components/WhyUs";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { SplashScreen } from "@/components/SplashScreen";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import Servizi from "@/pages/Servizi";

const Landing = () => {
    useEffect(() => {
        if (window.location.hash === "#contatti") {
            const t = setTimeout(() => scrollToId("contatti"), 600);
            return () => clearTimeout(t);
        }
    }, []);

    return (
        <div className="min-h-screen bg-[#F9F7F2]">
            <SplashScreen />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Services />
                <Portfolio />
                <WhyUs />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
        </div>
    );
};

function AppRouter() {
    const location = useLocation();
    // Detect OAuth session_id synchronously during render (prevents race conditions)
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Landing />} />
        </Routes>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <TextsProvider>
                <AppRouter />
                <Toaster position="bottom-right" richColors />
            </TextsProvider>
        </BrowserRouter>
    );
}

export default App;
